module.exports = {
  title: '售后订单',
  route: {
    path: '/admin-order-manage',
    children: {
      path: 'order-sales-after',
    },
  },
};
